import * as z from "zod/v4";

const updateOrderSelfServeInput = z.object({
  orderIdOrOrderNoOrConfirmationNo: z
    .string()
    .describe("The order number, ID, or confirmation number"),
  customerEmail: z
    .string()
    .describe("Customer's email address for verification"),
  operations: z
    .array(
      z.object({
        variantId: z.string().describe("The variant ID to add or remove"),
        quantity: z
          .number()
          .positive()
          .describe("The quantity to add or remove"),
        action: z.enum(["add", "remove"]).describe("The action to perform"),
      }),
    )
    .describe("Array of operations to perform on the order"),
});

const updateOrderSelfServeOutput = z.object({
  success: z.boolean(),
  orderNumber: z.string(),
  error: z.string().optional(),
  updatedItems: z
    .array(
      z.object({
        variantId: z.string(),
        action: z.enum(["add", "remove", "update"]),
        oldTotal: z.number(),
        newTotal: z.number(),
        quantity: z.number(),
        lineItemId: z.string().optional(),
        lineItemName: z.string().optional(),
        productTitle: z.string().optional(),
        variantTitle: z.string().optional(),
        sku: z.string().optional(),
      }),
    )
    .optional(),
});

export const updateOrderSelfServe = {
  name: "updateOrderSelfServe" as const,
  input: updateOrderSelfServeInput,
  output: updateOrderSelfServeOutput,
};
